import { render, staticRenderFns } from "./PosLoginForm.vue?vue&type=template&id=13b26124&scoped=true"
import script from "./PosLoginForm.vue?vue&type=script&lang=js"
export * from "./PosLoginForm.vue?vue&type=script&lang=js"
import style0 from "./PosLoginForm.vue?vue&type=style&index=0&id=13b26124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b26124",
  null
  
)

export default component.exports